import type {AdvancedTreeData} from "~/services/ApiTypes";
import {UNCATEGORIZED_LABEL, UNCATEGORIZED_VALUE} from "~/constants";

export const categoryDisplayLabel = (label: string) => label === UNCATEGORIZED_VALUE ? UNCATEGORIZED_LABEL : label;

/**
 * Spend of a category including everything below it. The API puts the spend on the deepest level,
 * so this adds it up the same way the treemap does (own value plus children).
 */
export function categoryTotal(node: AdvancedTreeData): number {
    return (node.value || 0) + (node.children ?? []).reduce((sum, c) => sum + categoryTotal(c), 0);
}

/** The node at `path` ([] is the root), or undefined when it is not in the tree */
export function categoryNode(root: AdvancedTreeData, path: ReadonlyArray<string | undefined>): AdvancedTreeData | undefined {
    let node: AdvancedTreeData | undefined = root;
    for (const label of path) {
        if (!label) break;
        node = node?.children.find(c => c.label === label);
        if (!node) return undefined;
    }
    return node;
}

/** The children of the node at `path`, or the top level for an empty path */
export function categoryChildren(root: AdvancedTreeData, path: ReadonlyArray<string | undefined>): AdvancedTreeData[] {
    return categoryNode(root, path)?.children ?? [];
}
